<template>
  <el-form-item>
    <el-date-picker
      v-model="dataObj"
      type="daterange"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      size="small"
      @change="change"
      :picker-options="pickerOptions"
    />
  </el-form-item>
</template>

<script>
import Util from "@/utils/index.js";

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: Object,
    field: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    startPlaceholder: {
      type: String,
      default: "",
    },
    endPlaceholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    change() {
      if (this.dataObj === "" || this.dataObj == null) {
        this.value[this.field + "StartAt"] = null;
        this.value[this.field + "EndAt"] = null;
        this.value[this.field + "SelectDF"] = false;
        return;
      }
      this.value[this.field + "SelectDF"] = true;
      if (this.type === "date") {
        this.value[this.field + "StartAt"] = Util.formatDate(this.dataObj[0]);
        this.value[this.field + "EndAt"] = Util.formatDate(this.dataObj[1]);
      } else {
        this.value[this.field + "StartAt"] = Util.formatDateTime(
          this.dataObj[0]
        );
        this.value[this.field + "EndAt"] = Util.formatDateTime(
          Util.endOfDay(this.dataObj[1])
        );
      }
    },
  },
};
</script>
